jQuery(document).ready(function($){
  var cookieNoticeRequired = ( Cookies.get( 'cookie-notice' ) === undefined );
  var aboutURL = WPURLS.siteurl;
  
  if( cookieNoticeRequired ){
    $( 'body' ).prepend('<div id="cookie-notice">' +
                '<p>Diese Website verwendet Cookies, um bestmögliche Funktionalität bieten zu können.</p>' +
                '<div id="cookie-interaction"><button id="cookie-ack">OK</button>' +
                '<a href="' + aboutURL + '">Mehr erfahren</a></div>' +
            '</div>');
  }
  
  $( '#cookie-ack' ).click( function() {
    Cookies.set( 'cookie-notice', '1', {expires: 30} );
    $( '#cookie-notice' ).remove();
  });
});